export const DEFAULT_PROFILE_IMAGE_PATH =
  '/images/user-profile-page/default-profile-picture.png';
